import axios, { AxiosInstance, AxiosResponse, AxiosError } from 'axios';
import store from '../store/store';
import { showMessage, hideMessage } from '../store/globalSlice';

const bffApiCaller: AxiosInstance = axios.create({
    baseURL: import.meta.env.VITE_API_BASE_URL_2,
    withCredentials: true, // CRITICAL: Allows the browser to handle the HttpOnly cookie
    headers: {
        'Content-Type': 'application/json',
        'Accept-Language': 'TR',
    },
});

const VENDOR_TOKEN_KEY = 'vendor_token';

bffApiCaller.interceptors.request.use(
    (config) => {
        if (config.url && config.url.includes('vendor')) {
            const token = sessionStorage.getItem(VENDOR_TOKEN_KEY);
            if (token) {
                config.headers['X-Vendor-Token'] = token;
            }
        }
        return config;
    },
    (error) => Promise.reject(error)
);

bffApiCaller.interceptors.response.use(
    (response: AxiosResponse) => {
        const token = response.headers['x-vendor-token'] || response.headers['X-Vendor-Token'];
        if (token) {
            sessionStorage.setItem(VENDOR_TOKEN_KEY, token);
        }
        return response;
    },
    (error: AxiosError) => {
        if (error.response) {
            console.error('API Error:', error.response.data);
            
            // "/v1/vendor/" isteklerinde 200 harici hata dönüyorsa global popup göster
            const configUrl = error.config?.url || '';
            if (configUrl.includes('/v1/vendor/')) {
                const errorData = error.response.data as any;
                if (errorData && errorData.message) {
                    let errorText = "Bir hata oluştu.";
                    if (Array.isArray(errorData.message) && errorData.message.length > 0) {
                        errorText = errorData.message.join('\n');
                    } else if (typeof errorData.message === 'string') {
                        errorText = errorData.message;
                    }
                    
                    store.dispatch(showMessage({
                        title: 'Hata',
                        text: errorText,
                        btnPrimaryText: 'Kapat',
                        btnPrimaryClassNames: "popup-btn-pink",
                        btnPrimaryCallback: () => {
                            store.dispatch(hideMessage());
                        }
                    }));
                }
            }

            // If the backend returns 401/403 (unauthorized/forbidden), we might need to re-verify
            if (error.response.status === 401 || error.response.status === 403) {
                if (error.response.status === 403) {
                    window.location.href = '/loan';
                }
            }

            // Rate limiting hatası geldiğinde kullanıcıyı bilgilendir
            if (error.response.status === 429) {
                store.dispatch(showMessage({
                    title: "İşlem Sınırı Aşıldı",
                    text: "Çok fazla deneme yaptınız. Lütfen daha sonra tekrar deneyiniz.",
                    btnPrimaryText: "Ana Sayfaya Dön",
                    btnPrimaryCallback: () => {
                        store.dispatch(hideMessage());
                        window.location.href = '/loan';
                    }
                }));
            }
        } else if (error.request) {
            console.error('No response received:', error.request);
        } else {
            console.error('Request setup error:', error.message);
        }
        return Promise.reject(error);
    }
);

export default bffApiCaller;
